import styled from 'styled-components';

export const InstructionsContainer = styled.div`
  max-width: 100%;
  margin: 0, auto;
  padding: 24px;
  text-align: left;

  @media (min-width: 1440px) {
    padding-left: 100px;
    padding-right: 200px;
    margin: 0 auto;
  }

    /* Мобильная адаптация только для главной страницы по ID */
  @media (max-width: 768px) {
    &#main-page {
      padding-left: 0px !important;
      padding-right: 0px !important;
      line-height: 1.3 !important;
      word-break: break-word;
      hyphens: auto;
  }}
`;

export const InstructionsContainerA = styled.div`
  max-width: 100%;
  margin: 0, auto;
  padding: 24px;
  text-align: left;

  @media (min-width: 1440px) {
    padding-left: 10px;
    padding-right: 50px;
    margin: 0 auto;
  }

    /* Мобильная адаптация только для главной страницы по ID */
  @media (max-width: 768px) {
    &#main-page {
      padding-left: 0px !important;
      padding-right: 0px !important;
      line-height: 1.3 !important;
      word-break: break-word;
      hyphens: auto;
  }}
`;

export const TextCenterContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 24px;
  text-align: center;

  @media (min-width: 1440px) {
    padding-left: 100px;
    padding-right: 100px;
    /* Можно добавить дополнительные стили */
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

export const H1 = styled.h1`
  font-family: 'Segoe UI', sans-serif;
  color: #0078d4;
  font-weight: bold;
  font-size: 32px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
   &#main-page-h1 {
    font-size: 24px;
  }}
`;

export const H2 = styled.h2`
  font-family: 'Segoe UI', sans-serif;
  color: #0078d4;
  font-weight: normal;
  font-size: 24px;
  margin-top: 32px;
  margin-bottom: 16px;

  @media (max-width: 768px) {
   &#main-page-h2 {
    font-size: 19px;
  }}
`;

export const H3 = styled.h3`
  font-family: 'Segoe UI', sans-serif;
  color: #0078d4;
  font-weight: normal;
  font-size: 20px;
  margin-top: 32px;
  margin-bottom: 16px;
`;

export const H4 = styled.h4`
  font-family: 'Segoe UI', sans-serif;
  color: #0078d4;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
  opacity: 0.4; 
`;


export const P = styled.p`
  font-family: 'Segoe UI', sans-serif;
  color: #000;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
`;

export const SL = styled.a`
  font-family: 'Segoe UI', sans-serif;
  color: #0078d4;
  font-style: italic;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const SP = styled.ul`
  list-style-type: disc;
  padding-left: 24px;
  font-family: 'Segoe UI', sans-serif;
  color: #000;

  li {
    margin-bottom: 8px;
  }
`;

export const IM = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 32px auto; /* отступы сверху и снизу + центрирование */
`;

export const IML = styled.img`
  float: left;
  max-width: 30%;
  height: auto;
  margin-right: 30px;
  margin-bottom: 16px;
  display: block;

  @media (max-width: 768px) {
    float: none;
    min-width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-top: 16px;
  }
`;

export const BC = styled.div`
  float: center;
  display: flex;
  gap: 12px;
  margin-left: 24px;
  margin-top: 50px;

  /* Базовый стиль для всех кнопок внутри */
  button {
    width: 100%;
    max-width: 100%;
    padding: 12px 16px;
    font-size:  15px;
    box-sizing: border-box;
    font-family: 'Segoe UI', sans-serif;
  }

  @media (max-width: 767px) {
    float: none;
    margin-top: 12px
    align-items: center;
    justify-content: center;
    flex-direction: column;

    button {
      max-width: 90%; /* чуть меньше ширины экрана */
      font-size: 18px; /* фиксируем размер текста */
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 80%;
    flex-direction: string;
    margin-top: 50px;

    button {
      font-size: 18px;
      white-space: normal;
    }
  }

  @media (min-width: 1024px) {
    max-width: 70%;
    flex-direction: string;
    margin-top: 150px;
      margin-left: 80px;

    button {
      font-size: 20px;
      white-space: normal;
    }
  }
`;

export const ImageWithButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ClearFloat = styled.div`
  clear: both;
`;